import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Schema from '..';
import { getProductSchema } from '../../../utils/metaContentHelper';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import isEqual from 'lodash/isEqual';

const ProductSchema = (props) => {
  const { listing, labels } = props;
  return <Schema data={getProductSchema(listing, labels)} />;
};

export default memo(ProductSchema, isEqual);

ProductSchema.propTypes = {
  labels: PropTypes.shape({
    getTitle: PropTypes.func.isRequired,
    getCurrency: PropTypes.func.isRequired,
  }).isRequired,
  listing: listingPropTypes,
};
